import { useEffect, useState } from 'react';
import { getTimeRemaining, hasTimeLeft } from '@utils/date-helpers';

export function useCountdownTimer(expiredAt) {
  // Считаем остаток сразу на первом рендере, иначе до первого эффекта
  // показывается 00:00 и кнопка успевает мигнуть активной.
  const [timeRemaining, setTimeRemaining] = useState(() =>
    expiredAt ? getTimeRemaining(expiredAt) : null,
  );

  useEffect(() => {
    if (!expiredAt) {
      setTimeRemaining(null);
      return;
    }

    const initialRemaining = getTimeRemaining(expiredAt);
    setTimeRemaining(initialRemaining);

    if (!hasTimeLeft(initialRemaining)) return;

    const interval = setInterval(() => {
      const remaining = getTimeRemaining(expiredAt);
      setTimeRemaining(remaining);
      if (!hasTimeLeft(remaining)) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiredAt]);

  return timeRemaining;
}
